import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.469 5.646a11.248 11.248 0 0 1 18.898 0 9.553 9.553 0 0 1 1.325 3.215c.363 1.554.43 3.172.372 4.678-.105 2.737-.832 5.222-2.315 7.042-1.51 1.853-3.726 2.919-6.568 2.919h-2.263a2 2 0 1 1 2-2h.263c2.293 0 3.919-.835 5.017-2.182a7.216 7.216 0 0 0 1.063-1.818h-2.343v-8h2.863a8.891 8.891 0 0 0-.04-.2c-.22-.932-.56-1.802-1.055-2.57a9.25 9.25 0 0 0-7.768-4.23 9.248 9.248 0 0 0-7.77 4.23A7.604 7.604 0 0 0 3.056 9.5h2.862v8h-2a3 3 0 0 1-3-3l.003-4.077c.126-1.623.548-3.229 1.549-4.777ZM21.05 11.5h-1.132v4h.925c.12-.638.195-1.32.223-2.039.026-.66.024-1.317-.016-1.961Zm-18.132 0v3a1 1 0 0 0 1 1v-4h-1Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconActionSupport24 = createIcon(IconComponent);